<template>
  <div :class="['message-row', message.role]">
    <div v-if="message.role === 'assistant'" class="avatar assistant-avatar">
      <font-awesome-icon :icon="['fas', 'robot']" />
    </div>

    <div :class="['bubble', message.role, { error: message.error }]">
      <p class="bubble-text">{{ message.text }}</p>

      <div v-if="message.role === 'assistant' && !message.error && message.canAnswer === false" class="confidence-badge">
        Limited confidence — answer may be incomplete
      </div>

      <CitationChips
        v-if="message.role === 'assistant' && message.citations?.length"
        :citations="message.citations"
      />
    </div>

    <div v-if="message.role === 'user'" class="user-avatar-group">
      <div class="avatar user-avatar">
        <font-awesome-icon :icon="['fas', 'user']" />
      </div>
      <span class="user-name-label">{{ userFirstName }}</span>
    </div>
  </div>
</template>

<script>
import CitationChips from './CitationChips.vue';

export default {
  name: 'ChatMessageBubble',
  components: {
    CitationChips,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    userFirstName: {
      type: String,
      default: 'You',
    },
  },
};
</script>

<style scoped>
.message-row {
  display: flex;
  align-items: flex-end;
  gap: 0.55rem;
  max-width: 92%;
}

.message-row.user {
  margin-left: auto;
  flex-direction: row;
}

.message-row.assistant {
  margin-right: auto;
}

.avatar {
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
}

.assistant-avatar {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.user-avatar {
  background: #047857;
  color: #ffffff;
}

.user-avatar-group {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.user-name-label {
  font-size: 0.6rem;
  color: var(--text-tertiary);
  max-width: 3rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bubble {
  padding: 0.75rem 0.95rem;
  border-radius: 1rem;
  font-size: 0.85rem;
  line-height: 1.45;
  box-shadow: 0 2px 10px var(--shadow-color);
}

.bubble.user {
  background: #059669;
  color: #ffffff;
  border-bottom-right-radius: 0.25rem;
}

.bubble.assistant {
  background: var(--card-bg);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-bottom-left-radius: 0.25rem;
}

.bubble.error {
  background: rgba(220, 38, 38, 0.08);
  border-color: rgba(220, 38, 38, 0.35);
  color: #b91c1c;
}

.dark-mode .bubble.error {
  background: rgba(248, 113, 113, 0.12);
  color: #fca5a5;
}

.bubble-text {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.85rem;
}

.confidence-badge {
  margin-top: 0.55rem;
  padding: 0.3rem 0.55rem;
  border-radius: 0.4rem;
  background: rgba(217, 119, 6, 0.12);
  color: #b45309;
  font-size: 0.68rem;
  font-weight: 500;
}

.dark-mode .confidence-badge {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
}

.chat-message-enter-active {
  animation: fadeInUp 0.35s ease both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
